module.exports = __webpack_public_path__ + "static/img/employee_01.941b439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/employee_01.png
// module id = b/o5
// module chunks = 0